import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody, Button, Alert} from 'reactstrap';
import {FormattedMessage} from "react-intl";
import Formsy from 'formsy-react';
import InputFormGroup from "components/Form/InputFormGroup";
import Loading from "components/Loading";
import {getStatusFromError} from "helpers/errors";

class NewNote extends React.Component {
    static propTypes = {
        onCreate: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.create = this.create.bind(this);
    }

    componentWillMount() {
        this.setState({
            opened: false,
        })
    }

    create(model) {
        this.setState({
            loading: true,
        });
        this.props.onCreate(model.note).then(() => {
            this.setState({
                loading: false,
                opened: false,
            });
        }).catch(e => {
            this.setState({
                loading: false,
                status: getStatusFromError(e),
            });
        });
    }

    toggle() {
        this.setState({
            opened: !this.state.opened
        });
    }

    render() {
        const {status, loading, valid} = this.state;

        return (
            <div>
                <Button block color="primary" outline className="mb-3 mt-3" onClick={this.toggle}>
                    <FormattedMessage id="conversation.write_note" defaultMessage="Write note"/>
                </Button>
                <Modal keyboard autoFocus isOpen={this.state.opened} modalClassName="modal-small" toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <FormattedMessage id="conversation.new_note" defaultMessage="New note"/>
                    </ModalHeader>
                    <ModalBody>
                        <Formsy className="form" onValidSubmit={this.create}
                                onInvalid={() => this.setState({valid: false})}
                                onValid={() => this.setState({valid: true})}>
                            <InputFormGroup type="textarea" id="form-note-new" name="note" label={(
                                <FormattedMessage id="conversation.new_note.text_label" defaultMessage="Note text"/>)}
                                            required
                            />

                            {status &&
                                <Alert color={status.type}>
                                    {status.message}
                                </Alert>
                            }

                            <Button type="submit" color="secondary" block
                                    disabled={!valid || loading}>
                                {loading &&
                                <Loading inline small/>
                                }
                                <FormattedMessage id="conversation.new_note.add" defaultMessage="Add"/>
                            </Button>
                        </Formsy>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default NewNote;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Notes/NewNote.jsx